export function formatPrice(
  price: number | null | undefined,
  currency: string | null | undefined,
): string | null {
  return price && currency ? `${price} ${currency}` : null;
}
